import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../Components/ComponentButton';
import T from '../../../Locale';
import { getTypesForSelect } from '../ValueTypes';
import Input from '../../../Components/ComponentInput';
import Select from '../../../Components/ComponentSelect';
class PageBasic extends Component {
    constructor(props) {
        super(props);
        this.state = { nameError: false };
        this.validateAndGo = this.validateAndGo.bind(this);
    }
    validateAndGo() {
        const { data, goToNextPage } = this.props;
        if (!data.name || !data.name.length) {
            this.setState({ nameError: true });
        }
        else {
            goToNextPage();
        }
    }
    render() {
        const { data, setData } = this.props;
        const { nameError } = this.state;
        return (_jsxs("div", { children: [_jsx("h5", { children: T.translate('values.type') }), _jsx("p", { children: T.translate('values.typeDescription') }), _jsx(Select, { onChange: (value) => { setData('type', value); }, defaultValue: data.type, options: getTypesForSelect() }), _jsx("br", {}), _jsx("br", {}), _jsx("h5", { children: T.translate('values.name') }), _jsx("p", { children: T.translate('values.nameDescription') }), _jsx(Input, { defaultValue: data.name, error: nameError, required: true, onKeyPress: () => this.setState({ nameError: false }), onChange: (value) => setData('name', value) }), _jsx("div", Object.assign({ className: "text-center" }, { children: _jsx(Button, Object.assign({ onClick: this.validateAndGo }, { children: T.translate('misc.next') })) }))] }));
    }
}
PageBasic.propTypes = {
    data: PropTypes.object.isRequired,
    goToNextPage: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired
};
export default PageBasic;
